export default {
  token: localStorage.getItem('user-token') || '',
  status: '',
  user: JSON.parse(localStorage.getItem('user-data')) || {},
}
